import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Dashboard from '../components/Dashboard';
import CultivoList from '../components/CultivoList';
import InsumoList from '../components/InsumoList';
import LaborList from '../components/LaborList';
import InversorList from '../components/InversorList';
import PropietarioList from '../components/PropietarioList';
import EstablecimientoList from '../components/EstablecimientoList';
import ActividadInversorList from '../components/ActividadInversorList';
import OrdenTrabajoViewer from '../components/OrdenTrabajoViewer';
import ProveedorList from '../components/ProveedorList';
import CampanaList from '../components/CampanaList';
import CampanaViewer from '../components/CampanaViewer';
import ProduccionList from '../components/ProduccionList';
import Breadcrumbs from '../components/Breadcrumbs';
import store from '../redux/store';
import { Provider } from 'react-redux';
import ActividadViewer from '../components/ActividadViewer';
import AlquilerViewer from '../components/AlquilerViewer';
import ContratoViewer from '../components/ContratoViewer';
import SociedadList from '../components/SociedadList';

const r = [
  { path: '/', name: 'Home', Component: Dashboard },
  { path: '/dashboard', name: 'Home', Component: Dashboard },
  { path: '/cultivos', name: 'Cultivos', Component: CultivoList },
  { path: '/insumos', name: 'Insumos', Component: InsumoList },
  { path: '/labores', name: 'Labores', Component: LaborList },
  { path: '/inversores', name: 'Aportantes', Component: InversorList },
  { path: '/sociedades', name: 'Sociedades', Component: SociedadList },
  {
    path: '/establecimientos',
    name: 'Establecimientos',
    Component: EstablecimientoList,
  },
  { path: '/propietarios', name: 'Propietarios', Component: PropietarioList },
  { path: '/proveedores', name: 'Proveedores', Component: ProveedorList },
  { path: '/campanas', name: 'Campañas', Component: CampanaList },
  { path: '/campanas/:id', name: '', Component: CampanaViewer },

  {
    path: '/campanas/:id/produccion',
    name: 'Producción',
    Component: CampanaViewer,
  },
  {
    path: '/campanas/:id/inversion',
    name: 'Inversión',
    Component: CampanaViewer,
  },

  {
    path: '/campanas/:id/alquileres',
    name: 'Alquileres',
    Component: CampanaViewer,
  },
  {
    path: '/campanas/:id/alquileres/:id2',
    name: '',
    Component: AlquilerViewer,
  },
  {
    path: '/campanas/:id/alquileres/:id2/contratos',
    name: 'Contratos',
    Component: AlquilerViewer,
  },
  {
    path: '/campanas/:id/alquileres/:id2/contratos/:id3',
    name: '',
    Component: ContratoViewer,
  },
  {
    path: '/campanas/:id/alquileres/:id2/contratos/:id3/cuotas',
    name: 'Cuotas',
    Component: ContratoViewer,
  },

  {
    path: '/campanas/:id/actividades',
    name: 'Actividades',
    Component: CampanaViewer,
  },
  {
    path: '/campanas/:id/actividades/:id2',
    name: '',
    Component: ActividadViewer,
  },
  {
    path: '/campanas/:id/actividades/:id2/resumen',
    name: 'Resumen',
    Component: ActividadViewer,
  },
  {
    path: '/campanas/:id/actividades/:id2/inversores',
    name: 'Aportantes',
    Component: ActividadInversorList,
  },
  {
    path: '/campanas/:id/actividades/:id2/ordenes-trabajo',
    name: 'Ordenes de Trabajo',
    Component: ActividadViewer,
  },
  {
    path: '/campanas/:id/actividades/:id2/ordenes-trabajo/:id3',
    name: 'Visor',
    Component: OrdenTrabajoViewer,
  },
  {
    path: '/campanas/:id/actividades/:id2/gastos',
    name: 'Gastos',
    Component: ActividadViewer,
  },
  {
    path: '/campanas/:id/actividades/:id2/retiros',
    name: 'Retiros',
    Component: ActividadViewer,
  },
  {
    path: '/campanas/:id/actividades/:id2/produccion',
    name: 'Producción',
    Component: ProduccionList,
  },
];

const routes = (
  <Provider store={store}>
    <Switch>
      {r.map(({ path, name, Component }, key) => (
        <Route
          exact
          path={path}
          key={key}
          render={(props) => {
            const crumbs = r
              .filter(({ path }) => props.match.path.includes(path))
              .map(({ path, ...rest }) => ({
                path: Object.keys(props.match.params).length
                  ? Object.keys(props.match.params).reduce(
                      (path, param) =>
                        path.replace(`:${param}`, props.match.params[param]),
                      path
                    )
                  : path,
                ...rest,
              }));
            return (
              <div
                style={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Breadcrumbs crumbs={crumbs} />
                <div style={{ flex: '1' }}>
                  <Component {...props} />
                </div>
              </div>
            );
          }}
        />
      ))}
    </Switch>
  </Provider>
);

export default routes;
